<template>
  <div class="clipboard-copy">
    <el-input type="text" autocomplete="off" readonly :value="value"> </el-input>
    <el-button
      v-clipboard:copy="value"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
      icon="el-icon-clipboard"
    />
  </div>
</template>

<script>
export default {
  name: 'ClipboardCopy',
  props: {
    value: {
      type: String,
      default: () => {
        return '';
      }
    }
  },
  methods: {
    onCopy(e) {
      this.$emit('copy', this.value);
    },
    onError(e) {
      this.$emit('error', e);
    }
  }
};
</script>

<style lang="scss" scoped>
@import './clipboardCopy.scss';
</style>
